module.exports = __webpack_public_path__ + "static/media/крымская-зима.7aba7ab3.jpg";